const IPV4 = /^\d{1,3}(\.\d{1,3}){3}$/;

/** Sibling service URL on the parent domain: `app.dev.vammo.com` + `auth` -> `https://auth.dev.vammo.com`. */
const fromHost = (service: string): string => {
  const host = window.location.hostname;
  if (!host || host === "localhost" || IPV4.test(host) || host.includes(":")) return "";
  const labels = host.split(".");
  if (labels.length < 2) return "";
  return `https://${service}.${labels.slice(1).join(".")}`;
};

// Cactus does not pass static-frontend env vars as build args, so VITE_* is empty in deployed
// bundles. Fall back to the host-derived URL; local dev must set VITE_*.
export const authUrl = (): string => (import.meta.env.VITE_AUTH_URL as string | undefined) || fromHost("auth");
export const apiBase = (): string => (import.meta.env.VITE_API_BASE_URL as string | undefined) || fromHost("api");
